import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { renderSR } from '../../utils/common';

const MENU_ITEMS = [
  { id: 1, text: 'home', auth: [1, 2, 3, 4, 5] },
  { id: 2, text: 'users', auth: [1, 2, 3, 4, 5] },
  { id: 3, text: 'platforms', auth: [1, 2, 3, 4, 5] },
  { id: 4, text: 'pricing', auth: [1, 2, 3, 4, 5] },
  { id: 5, text: 'data', auth: [1, 2, 3, 4, 5] },
  { id: 6, text: 'orders', auth: [1, 2, 3, 4, 5] },
  {
    id: 7,
    text: 'reports',
    auth: [1, 2, 3, 4, 5],
    submenu: [
      { id: 1, text: 'order-reports', auth: [1, 2, 3, 4, 5] },
      { id: 2, text: 'data-reports', auth: [1, 2, 4] },
      // { id: 2, text: 'order-reports', auth: [1, 2, 3, 5] },
      // { id: 3, text: 'billing-reports', auth: [1, 2, 3, 5] },
      // { id: 4, text: 'activity-reports', auth: [1, 2, 3] },
    ],
  },
];

export default class Sidebar extends React.Component {
  static propTypes = {
    accountSettings: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    highlight: PropTypes.string.isRequired,
    userTypeId: PropTypes.number.isRequired,
  };

  static defaultProps = {
    isAdmin: false,
  };

  state = { submenuActive: '' };

  componentWillMount = () => {
    const { highlight, isAdmin } = this.props;
    if (!isAdmin) {
      let submenuActive = '';
      MENU_ITEMS.forEach(item => {
        if (item.submenu) {
          item.submenu.forEach(subItem => {
            if (highlight === subItem.text) {
              submenuActive = item.text;
            }
          });
        }
      });
      this.setState({ submenuActive });
    }
  };

  toggleSubmenuActive = text => e => {
    e && e.preventDefault();
    this.setState(prevState => {
      if (prevState.submenuActive === text) {
        return { submenuActive: '' };
      }
      return { submenuActive: text };
    });
  };

  renderAdminLinks = () => {
    const { highlight } = this.props;
    const adminBasePath = 'superadmin';
    const nav = {
      home: {
        title: 'admin home',
        key: 'home',
        path: '/home',
      },
      accounts: {
        title: 'accounts',
        key: 'all-accounts',
        path: `/${adminBasePath}/accounts`,
      },
      listAccounts: {
        title: 'list accounts',
        key: 'accounts',
        path: `/${adminBasePath}/accounts`,
      },
      createAccount: {
        title: 'create account',
        key: 'create',
        path: `/${adminBasePath}/create`,
      },
      datasets: {
        title: 'datasets',
        key: 'listsummary',
        path: `/${adminBasePath}/listsummary`,
      },
      orders: {
        title: 'orders',
        key: 'orders',
        path: `/${adminBasePath}/orders`,
      },
      platforms: {
        title: 'platforms',
        key: 'platforms',
        path: `/${adminBasePath}/platforms`,
      },
      token: {
        title: 'token',
        key: 'token',
        path: `/${adminBasePath}/token`,
      },
      listJobs: {
        title: 'jobs',
        key: 'jobs',
        path: `/${adminBasePath}/jobs`,
      },
      pricing: {
        title: 'pricing',
        key: 'pricing',
        path: `/${adminBasePath}/pricing`,
      },
    };

    let submenuActive = false;
    if (highlight === nav.listAccounts.key || highlight === nav.createAccount.key) {
      submenuActive = true;
    }

    return (
      <div>
        <li className={highlight === nav.home.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.home.path}>
            <span className={`menu-icon ${nav.home.key}`} />
            {nav.home.title}
            {highlight === nav.home.key ? this.renderCurrent() : null}
          </Link>
        </li>
        <li
          className={
            highlight === nav.accounts.key || submenuActive ? 'sidebar-item active' : 'sidebar-item'
          }
        >
          <Link className="nav-link" to={nav.accounts.path}>
            <span className={`menu-icon ${nav.accounts.key}`} />
            {nav.accounts.title}
            {highlight === nav.accounts.key ? this.renderCurrent() : null}
            <i
              className={`fa pull-right ${
                submenuActive ? 'fa-minus-square-o' : 'fa-plus-square-o'
              }`}
            />
          </Link>
          <ul className={`submenu ${submenuActive ? 'open' : 'collapse'}`}>
            <li
              className={
                highlight === nav.listAccounts.key ? 'sidebar-item active' : 'sidebar-item'
              }
            >
              <Link className="nav-link" to={nav.listAccounts.path}>
                {nav.listAccounts.title}
                {highlight === nav.listAccounts.key ? this.renderCurrent() : null}
              </Link>
            </li>
            <li
              className={
                highlight === nav.createAccount.key ? 'sidebar-item active' : 'sidebar-item'
              }
            >
              <Link className="nav-link" to={nav.createAccount.path}>
                {nav.createAccount.title}
                {highlight === nav.createAccount.key ? this.renderCurrent() : null}
              </Link>
            </li>
          </ul>
        </li>
        <li className={highlight === nav.datasets.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.datasets.path}>
            <span className={`menu-icon ${nav.datasets.key}`} />
            {nav.datasets.title}
            {highlight === nav.datasets.key ? this.renderCurrent() : null}
          </Link>
        </li>
        <li className={highlight === nav.orders.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.orders.path}>
            <span className={`menu-icon ${nav.orders.key}`} />
            {nav.orders.title}
            {highlight === nav.orders.key ? this.renderCurrent() : null}
          </Link>
        </li>
        <li className={highlight === nav.platforms.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.platforms.path}>
            <span className={`menu-icon ${nav.platforms.key}`} />
            {nav.platforms.title}
            {highlight === nav.platforms.key ? this.renderCurrent() : null}
          </Link>
        </li>
        <li className={highlight === nav.token.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.token.path}>
            <span className={`menu-icon ${nav.token.key}`} />
            {nav.token.title}
            {highlight === nav.token.key ? this.renderCurrent() : null}
          </Link>
        </li>
        <li className={highlight === nav.listJobs.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.listJobs.path}>
            <span className={`menu-icon ${nav.listJobs.key}`} />
            {nav.listJobs.title}
            {highlight === nav.listJobs.key ? this.renderCurrent() : null}
          </Link>
        </li>
        <li className={highlight === nav.pricing.key ? 'sidebar-item active' : 'sidebar-item'}>
          <Link className="nav-link" to={nav.pricing.path}>
            <span className={`menu-icon ${nav.pricing.key}`} />
            {nav.pricing.title}
            {highlight === nav.pricing.key ? this.renderCurrent() : null}
          </Link>
        </li>
      </div>
    );
  };

  renderNavLinks = item => {
    const { highlight, userTypeId, accountSettings } = this.props;
    const { submenuActive } = this.state;
    let showItem = true;
    const toLink = `/${item.text}`;
    const disabled = item.auth.indexOf(userTypeId) < 0;
    const isSubmenuActive = item.text === submenuActive;
    const hasSubmenu = item.submenu && item.submenu.length > 0;

    if (item.text === 'pricing' && accountSettings.get('PRICING_ENABLED') === false) {
      showItem = false;
    }

    if (showItem && !item.submenu) {
      return (
        <li
          key={item.text}
          className={highlight === item.text ? 'sidebar-item active' : 'sidebar-item'}
        >
          <Link
            className={disabled ? 'nav-link disabled' : 'nav-link'}
            to={toLink}
            onClick={() => {
              if (disabled) return e => e.preventDefault();
              else if (hasSubmenu) return this.toggleSubmenuActive(item.text);
              return null;
            }}
          >
            <span className={`menu-icon ${item.text}`} />
            {item.text}
            {highlight === item.text ? this.renderCurrent() : null}
          </Link>
        </li>
      );
    } else if (showItem && item.submenu) {
      let isHighlight = false;
      item.submenu.forEach(submenuItem => {
        if (submenuItem.text === highlight) isHighlight = !isHighlight;
      });
      return (
        <li
          key={item.text}
          className={`${isHighlight ? 'sidebar-item active' : 'sidebar-item'} with-submenu`}
        >
          <Link
            className={`${disabled ? 'nav-link disabled' : 'nav-link'} primary`}
            to={toLink}
            onClick={this.toggleSubmenuActive(item.text)}
          >
            <span className={`menu-icon ${item.text}`} />
            {item.text}
            {highlight === item.text ? this.renderCurrent() : null}
            <i
              className={`fa pull-right ${
                submenuActive ? 'fa-minus-square-o' : 'fa-plus-square-o'
                }`}
            />
          </Link>
          <ul className={`submenu ${isSubmenuActive ? 'open' : 'collapse'}`}>
            {item.submenu.map(this.renderNavSubmenu)}
          </ul>
        </li>
      );
    }
    return null;
  };

  renderNavSubmenu = submenuItem => {
    const { highlight, userTypeId } = this.props;
    const title = submenuItem.text.split('-').join(' ');
    const toLink = `/${submenuItem.text}`;
    const disabled = submenuItem.auth.indexOf(userTypeId) < 0;

    return !disabled ? (
      <li
        key={submenuItem.text}
        className={highlight === submenuItem.text ? 'sidebar-item active' : 'sidebar-item'}
      >
        <Link
          className={disabled ? 'nav-link disabled' : 'nav-link'}
          to={toLink}
          onClick={disabled ? e => e.preventDefault() : null}
        >
          {title}
          {highlight === submenuItem.text ? this.renderCurrent() : null}
        </Link>
      </li>
    ) : null;
  };

  renderCurrent = () => renderSR('(current)');

  render() {
    const { isAdmin } = this.props;

    return (
      <div className="sidebar-wrapper">
        <nav className="nav">
          <ul className={isAdmin ? 'sidebar-nav admin-nav' : 'sidebar-nav'}>
            {isAdmin ? this.renderAdminLinks() : MENU_ITEMS.map(this.renderNavLinks)}
          </ul>
        </nav>
      </div>
    );
  }
}
